import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useFormInputNumberStyles = makeStyles()((theme: Theme) => ({
	label: {
		marginBottom: theme.spacing(1),
		marginTop: 0,
		fontWeight: theme.typography.fontWeightMedium,
	},
	inputField: {
		height: theme.spacing(5),
	},
	inputMultiline: {
		padding: theme.spacing(0.25, 0.5),
	},
	input: {
		padding: theme.spacing(1, 1.5),
		"&:disabled": {
			cursor: "not-allowed",
			pointerEvents: "auto",
		},
		"&[type=number]": {
			MozAppearance: "textfield",
		},
		"&::-webkit-outer-spin-button": {
			WebkitAppearance: "none",
			margin: 0,
		},
		"&::-webkit-inner-spin-button": {
			WebkitAppearance: "none",
			margin: 0,
		},
	},
}));
